module.exports = __webpack_public_path__ + "static/media/value.5eadb04f.svg";